import React from 'react';
import {
    ButtonGroup as MUIButtonGroup,
} from '@saddlebackchurch/react-cm-ui';
import withStyles from '@saddlebackchurch/react-cm-ui/core/styles/withStyles';
import {
    SelectOption,
} from '../../../../global/models';

type PropTypes = {
    onChange: () => void;
    buttons: SelectOption<string | number>[];
    classes: {
        root: string;
    };
    value: string;
};

function ButtonGroup({
    onChange,
    buttons,
    classes = undefined,
    value,
}: PropTypes) {
    return (
        <div className={classes.root}>
            <MUIButtonGroup
                onChange={onChange}
                buttons={buttons}
                value={value}
            />
        </div>
    );
}

const ButtonGroupWithStyles = withStyles((theme) => {
    const {
        palette,
        spacing,
        typography,
    } = theme;
    return {
        root: {
            '& .MuiButton-root': {
                paddingTop: 18,
                paddingBottom: 18,
            },
            '& .MuiButton-label': {
                fontSize: typography.pxToRem(16),
                fontWeight: typography.fontWeightRegular,
            },
            '& .MuiButtonGroup-root': {
                marginBottom: spacing(1),
                width: ({ fullWidth }) => (fullWidth ? '100%' : 'auto'),
                display: ({ fullWidth }) => (fullWidth ? 'flex' : 'unset'),
                borderRadius: 5,
            },
            '& .MuiButtonGroup-grouped': {
                flex: '1 1 auto',
            },
            '& .MuiButton-containedPrimary': {
                backgroundColor: '#4981F0',
            },
            '& .MuiButton-outlinedPrimary': {
                color: palette.grey[600],
                borderColor: palette.border.secondary,
                backgroundColor: palette.background.default,
            },
        },
    };
})(ButtonGroup);

export default ButtonGroupWithStyles;
